export const techs = [
    {
        name: 'JavaScript',
        iconName: 'javascript'
    },
    {
        name: 'Ruby',
        iconName: 'ruby'
    },
    {
        name: 'Swift',
        iconName: 'swift'
    },
    {
        name: 'HTML 5',
        iconName: 'html5'
    },
    {
        name: 'CSS',
        iconName: 'css3'
    },
    {
        name: 'SASS',
        iconName: 'sass'
    },
    {
        name: 'React',
        iconName: 'react'
    },
    // {
    //     name: 'Rails',
    //     iconName: 'ruby_on_rails'
    // },
    {
        name: 'PostgreSQL',
        iconName: 'postgresql'
    },
    {
        name: 'MongoDB',
        iconName: 'mongodb'
    },
    {
        name: 'Github',
        iconName: 'github_badge'
    },
    {
        name: 'Git',
        iconName: 'git'
    },
    {
        name: 'Bootstrap',
        iconName: 'bootstrap'
    },
    {
        name: 'Node',
        iconName: 'nodejs_small'
    },
]